import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { FilterOnlyKomitentComponent } from '../_filters/filter-only-komitent.component';
import { VrstaStavkiKodKupca } from './vrsta-stavki-kod-kupca';

@Component({
  selector: 'yt-vrsta-stavki-kod-kupca',
  templateUrl: './vrsta-stavki-kod-kupca.component.html'
})
export class VrstaStavkiKodKupcaComponent extends BaseModalContainer<VrstaStavkiKodKupca> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaStavkiKodKupca>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

   @ViewChild("filterFak", { static: true }) filterFak: FilterOnlyKomitentComponent;

  ngOnInit() {
    
  }

}
